// Copyright (c) 2016 Deere & Company

import audits from './audits';
import claimDebit from './claim-debit';
import partialDebit from './partial-debit';
import percentageDebit from './percentage-debit';
import prepareAudit from './prepare-audit';
import recordAudit from './record-audit';
import reports from './reports';
import wip from './wip';

export default {
    childRoutes: [
        audits,
        claimDebit,
        partialDebit,
        percentageDebit,
        prepareAudit,
        recordAudit,
        reports,
        wip
    ],
    indexRoute: {
        onEnter: (nextState, replace) => replace('/tcsm/wip')
    },
    name: 'TCSM',
    path: 'tcsm'
};



// WEBPACK FOOTER //
// ./src/routes/tcsm/index.js